// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2ZX8x","options":"AnswerScale_options__8U9rh","selected":"AnswerScale_selected__Ma14y"};